module.exports = __webpack_public_path__ + "img/balanceTempoTension1.6f15e83a.png";